"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Layout_1 = __importDefault(require("../Layout"));

var classnames_1 = require("./classnames");

var ChatIcon_1 = __importDefault(require("../ChatIcon"));

function Picture(props) {
  var isChatIconVisible = props.isChatIconVisible,
      icon = props.icon,
      handleClick = props.handleClick,
      url = props.url;
  return React.createElement(Layout_1.default, {
    isUser: false
  }, React.createElement("div", {
    className: classnames_1.wrapper
  }, isChatIconVisible && React.createElement(ChatIcon_1.default, {
    icon: icon,
    isUser: false
  }), React.createElement("div", {
    className: classnames_1.container,
    onClick: handleClick
  }, url && React.createElement("div", {
    className: classnames_1.pictureWidget,
    style: {
      background: "url(".concat(url, ") no-repeat center center"),
      backgroundSize: "cover"
    }
  }))));
}

exports.default = Picture;